export default "__VITE_PUBLIC_ASSET__d77c829e__"